import React, { useState } from 'react';
import { ChevronRight } from 'lucide-react';
import { Button } from '../../../components/ui/button';
import { InputField } from '../../../components/ui/input-field';

interface MessageInputProps {
    onSendMessage: (message: string) => void;
}

const MessageInput: React.FC<MessageInputProps> = ({ onSendMessage }) => {
    const [message, setMessage] = useState('');

    const handleSubmit = (e: React.FormEvent) => {
        e.preventDefault();
        if (message.trim()) {
            onSendMessage(message.trim());
            setMessage('');
        }
    };

    return (
        <form onSubmit={handleSubmit} className="flex items-center gap-3 mb-[-2%]">
            <div className="flex-1 relative mt-5">
                <InputField
                    type="text"
                    label=""
                    name="mensaje"
                    value={message}
                    icon=" "
                    onChange={(e) => setMessage(e.target.value)}
                    placeholder="Escribe tu mensaje"
                    className="w-full bg-maxi-gray-light text-maxi-text-dark placeholder-maxi-text focus:outline-none  focus:ring-maxi-green focus:border-transparent"
                />
            </div>
            <Button
                variant="default"
                type="submit"
                size="icon"
                className="rounded-full p-4"
            >
                <span className="flex items-center">
                    <ChevronRight className="w-4 h-4" />
                    <ChevronRight className="w-4 h-4 -ml-2" />
                </span>
            </Button>
        </form>
    );
};

export default MessageInput;
